import { Component, input } from '@angular/core';
import { I18nModule } from '@spartacus/core';
import { OpenInvoiceItem } from '../../models/make-payment.model';
import { InvoiceUtils } from '../../utils/invoice.utils';
import { PaymentInfo } from '../../models/payment-info.model';

@Component({
  selector: 'sanofi-payment-method',
  standalone: true,
  imports: [ I18nModule ],
  templateUrl: './payment-method.component.html',
})
export class PaymentMethodComponent {
  paymentInfo = input.required<OpenInvoiceItem | PaymentInfo>();
  protected readonly InvoiceUtils = InvoiceUtils;
  protected readonly JSON = JSON;
}
